import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {MaterializeAgent} from "../../api/agent/materializeAgent";
import {MultipartUtils} from "../../../../core/multipart.utils";

@Injectable({
    providedIn: "root",
})
export class MaterializeAgentScanner {

    constructor(private httpClient: HttpClient) {
    }

    listScanners(token: string): Promise<MaterializeScannersResponse> {
        return this.httpClient.get<MaterializeScannersResponse>(MaterializeAgent.API_BASE_URL + '/v1/scanners',{
            headers: new HttpHeaders({
                Authorization: `Bearer ${token}`
            })
        })
            .toPromise();
    }

    retrieveScanData(name:string, token: string, format: 'stl' | 'obj'): Promise<MaterializeScanData> {
        return new Promise((resolve, reject) => {
            this.httpClient.get(MaterializeAgent.API_BASE_URL + '/v1/scans/' + name, {
                headers: new HttpHeaders({
                    Authorization: `Bearer ${token}`,
                    'Accept': 'multipart/mixed',
                    'scanFormatEncoding': format
                }),
                responseType: 'arraybuffer',
                observe: 'response'
            })
                .toPromise()
                .then((response) => {
                    const parts: ArrayBuffer[] = MultipartUtils.parseMultipart(response);
                    // console.log('parts', parts);
                    if (parts.length !== 3) {
                        throw new Error('Rest multipart response must have 3 body parts');
                    }
                    // console.log(MultipartUtils.readJsonFromPart(parts[0]));
                    resolve({
                        name,
                        picture: MultipartUtils.readBlobFromPart(parts[2], 'image/png'),
                        data: MultipartUtils.readBlobFromPart(parts[1])
                    })
                })
                .catch((e) => reject(e));
        });
    }

    startRecording(name: string,
                   token: string,
                   scannerId: number,
                   side: 'left' | 'right',
                   lightSensitivity: 'VeryLow' | 'Low' | 'High' | 'VeryHigh' | 'Average'): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.httpClient.post<void>(MaterializeAgent.API_BASE_URL + '/v1/scans/' + name, {}, {
                headers: new HttpHeaders({
                    Authorization: `Bearer ${token}`
                })
            })
                .toPromise()
                .catch((e) => reject(e))
                .then(() => {
                    this.httpClient.post<void>(MaterializeAgent.API_BASE_URL + '/v1/scanners/' + scannerId + '/scan', {
                        name,
                        left: side === 'left' ? name : undefined,
                        right: side === 'right' ? name : undefined,
                        scanImage: 'true',
                        lightSensitivity,
                        geometry: 'open'
                    }, {
                        headers: new HttpHeaders({
                            Authorization: `Bearer ${token}`
                        })
                    }).toPromise()
                        .then(() => resolve())
                        .catch((err) => reject(err));
                })
        });
    }
}

export class MaterializeScannersResponse {
    scanners: MaterializeScanner[] = [];
}

export class MaterializeScanner {
    brand: string;
    firmware: string;
    id: number;
    licensed: string;
    model: string;
    serial: string;
    state: 'measuring' | 'ready' | 'error' | 'disconnected' | 'unavailable';
}

export class MaterializeScan {
    name: string
    state: 'scanning' | 'processing' | 'finished' | 'failed' ;
}

export class MaterializeScanData {
    name: string;
    picture: Blob;
    data: Blob;
}
